<template>
	<div class="space-y-4">
		<div class="space-y-1">
			<label class="block text-sm font-medium text-gray-700">Publish Date</label>
			<div class="gap-2 flex items-center">
				<button
					@click="updatePublishOption('now')"
					class="px-3 py-2 rounded-md cursor-pointer transition-all duration-200 text-sm font-medium outline outline-2 outline-offset-2"
					:class="publishOption === 'now' ? 'outline-black' : 'bg-white text-gray-700 outline-white/0 hover:outline-black/20 hover:bg-gray-50'"
				>
					Now
				</button>
				<button
					@click="updatePublishOption('schedule')"
					class="px-3 py-2 rounded-md cursor-pointer transition-all duration-200 text-sm font-medium outline outline-2 outline-offset-2"
					:class="publishOption === 'schedule' ? 'outline-black' : 'bg-white text-gray-700 outline-white/0 hover:outline-black/20 hover:bg-gray-50'"
				>
					Schedule
				</button>
			</div>
		</div>

		<!-- Date picker shown only when Schedule is selected -->
		<div v-if="publishOption === 'schedule'" class="space-y-1">
			<label for="publishSchedulerDate" class="block text-sm font-medium text-gray-700">Post Date</label>
			<input 
				v-model="postDate"
				type="datetime-local" 
				id="publishSchedulerDate" 
				class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent text-sm bg-white"
				placeholder="Select date and time"
			/>
			<p v-if="showHelperText" class="text-xs text-gray-500 italic">
				Scheduling will automatically enable matching entries and mark them as pending until that date.
			</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PublishScheduler',
	props: {
		modelValue: {
			type: Object,
			default: () => ({
				publishOption: null, // No default selection
				postDate: ''
			})
		},
		showHelperText: {
			type: Boolean,
			default: false
		}
	},
	emits: ['update:modelValue'],
	data() {
		return {
			publishOption: this.modelValue?.publishOption || null, // No default selection
			postDate: this.modelValue?.postDate || ''
		}
	},
	watch: {
		modelValue: {
			handler(newVal) {
				if (newVal) {
					this.publishOption = newVal.publishOption || null
					this.postDate = newVal.postDate || ''
				}
			},
			deep: true
		},
		publishOption(newVal) {
			this.emitUpdate()
		},
		postDate(newVal) {
			this.emitUpdate()
		}
	},
	methods: {
		updatePublishOption(option) {
			this.publishOption = option
			if (option === 'now') {
				this.postDate = ''
			}
		},
		emitUpdate() {
			this.$emit('update:modelValue', {
				publishOption: this.publishOption,
				postDate: this.postDate
			})
		}
	}
}
</script>